import { theme } from 'antd';
import type { CSSProperties } from 'react';
import {
  collapseAllNested,
  defaultStyles,
  JsonView,
} from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import './json-view.css';

const treeStyles = {
  ...defaultStyles,
  container: 'session-json-tree',
  label: 'session-json-label',
  stringValue: 'session-json-string',
  numberValue: 'session-json-number',
  booleanValue: 'session-json-boolean',
  nullValue: 'session-json-muted',
  punctuation: 'session-json-muted',
  quotesForFieldNames: true,
  stringifyStringValues: true,
  ariaLables: {
    collapseJson: '折叠 JSON 节点',
    expandJson: '展开 JSON 节点',
  },
};

// The SDK takes objects/arrays. JSONL scalar values remain valid records and
// are displayed directly, without adding a synthetic field to their data.
export function JsonLineView({ value }: { value: unknown }) {
  const { token } = theme.useToken();
  const style = {
    fontFamily: token.fontFamilyCode,
    color: token.colorText,
    '--session-json-string': token.colorSuccessText,
    '--session-json-number': token.colorInfoText,
    '--session-json-boolean': token.colorWarningText,
    '--session-json-muted': token.colorTextSecondary,
  } as CSSProperties;
  return (
    <div className="max-h-80 overflow-auto text-xs" style={style}>
      {value !== null && typeof value === 'object' ? (
        <JsonView
          data={value}
          style={treeStyles}
          shouldExpandNode={collapseAllNested}
          aria-label="JSON 树形预览"
        />
      ) : (
        <pre className="m-0 whitespace-pre-wrap break-all">
          {JSON.stringify(value)}
        </pre>
      )}
    </div>
  );
}
